import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getLmsCourses(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/`, { params });
    return res.data;
  },
  async getCourses(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/`, { params });
    return res.data;
  },
  async getCourse(_obj, id) {
    const res = await axios.get(`api/lms/lms-courses/${id}/`);
    return res.data;
  },
  async createCourse(_obj, data) {
    const res = await axios.post(`api/lms/lms-courses/`, data);
    return res.data;
  },
  async updateCourse(_obj, { id, data }) {
    const res = await axios.patch(`api/lms/lms-courses/${id}/`, data);
    return res.data;
  },
  async deleteCourse(_obj, id) {
    const res = await axios.delete(`api/lms/lms-courses/${id}/`);
    return res.data;
  },
  async getCourseImageUploadPresignedUrl(_obj, data) {
    const res = await axios.post(`api/lms/lms-courses/upload-url/`, data);
    return res.data;
  },
  async getProgramCourses(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/program-courses/`, { params });
    return res.data;
  },
  async getProgramAssignedCourses(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/program-assigned-courses/`, { params });
    return res.data;
  },
  async canUpdateCourseCategory(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/can-update-course-category/`, { params });
    return res.data;
  },
  async getStdAssignedCourse(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/std-assigned-courses/`, { params });
    return res.data;
  },
  async getSuperCourseDetail(_obj, params) {
    const res = await axios.get(`api/lms/lms-courses/super-course-detail/`, { params });
    return res.data;
  },
  async scaleWeightages(_obj, id) {
    const res = await axios.post(`api/lms/lms-courses/${id}/scale-weightages/`);
    return res.data;
  },
  async getCourseAnalytics(_obj, params) {
    const res = await axios.get(`api/lms/course-log/course-analytics/`, { params });
    return res.data;
  },
  async getCourseStudentsReport(_obj, params) {
    const res = await axios.get(`api/lms/course-log/course-students-report/`, { params });
    return res.data;
  },
  async getSuperAnalyticsSchoolsOverview(_obj, params) {
    const res = await axios.get(`api/lms/super-analytics/schools-overview/`, { params });
    return res.data;
  },
  async getSuperAnalyticsSchoolCourses(_obj, params) {
    const res = await axios.get(`api/lms/super-analytics/school-courses/`, { params });
    return res.data;
  },
  async getSuperAnalyticsCourseStructurePerformance(_obj, params) {
    const res = await axios.get(`api/lms/super-analytics/course-structure-performance/`, { params });
    return res.data;
  },
  async getCourseGradebook(_obj, params) {
    const res = await axios.get(`api/lms/course-log/course-gradebook/`, { params });
    return res.data;
  },
  // Give a student additional attempts on a quiz, on top of Quiz.max_attempts.
  // Additive rather than a reset: the attempt history is preserved for audit.
  async grantExtraQuizAttempts(_obj, data) {
    const res = await axios.post(`api/lms/quiz-results/grant-extra-attempts/`, data);
    return res.data;
  },
  async getCohortCourseConfig(_obj, params) {
    const res = await axios.get(`api/lms/cohort-course-config/config-data/`, { params });
    return res.data;
  },
  async setupCohortCourseConfig(_obj, data) {
    const res = await axios.post(`api/lms/cohort-course-config/setup/`, data);
    return res.data;
  },
  async duplicateCourse(_obj, { id, data }) {
    const res = await axios.post(`api/lms/lms-courses/${id}/duplicate-course/`, data);
    return res.data;
  },
};

export const courses = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
